'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import * as React from 'react';
import { createTheme, Theme, useTheme } from '@mui/material';
import { TenantConfig } from '@jd/client/tenant/getSiteConfig';

type TenantContext = {
  tenantConfig: TenantConfig;
  theme: Theme;
  allLocales: string[];
};

export const TenantContext = createContext<TenantContext>({
  tenantConfig: {
    id: '',
    header: {
      cta: {
        label: '',
      },
    },
    updatedAt: '',
    createdAt: '',
  },
  theme: createTheme(),
  allLocales: [],
});

export type TenantProviderProps = {
  tenantConfig: TenantContext['tenantConfig'];
  allLocales: string[];
};

export const TenantProvider = ({
  children,
  allLocales,
  tenantConfig,
}: PropsWithChildren<TenantProviderProps>) => {
  const theme = useTheme();

  return (
    <TenantContext.Provider value={{ tenantConfig, theme, allLocales }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
